module.exports = __webpack_public_path__ + "static/img/cruelty_child_2_en.82c0f8ba.png";